module.exports = __webpack_public_path__ + "static/media/SVG_tag.1e6bdee6.svg";